import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Zap, Smartphone } from 'lucide-react';
import type { ConversationChannel } from '../hooks/useConversation';

interface ConversationSelectorProps {
  value: ConversationChannel;
  onChange: (val: ConversationChannel) => void;
}

export function ConversationSelector({ value, onChange }: ConversationSelectorProps) {
  return (
    <div className="px-4 py-2 border-b bg-muted/30 flex items-center gap-2 flex-shrink-0">
      <span className="text-xs text-muted-foreground">Conversa:</span>
      <Select value={value} onValueChange={(v) => onChange(v as ConversationChannel)}>
        <SelectTrigger className="h-7 w-[140px] text-xs">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="twilio">
            <div className="flex items-center gap-2">
              <Zap className="h-3 w-3 text-blue-500" />
              Comercial
            </div>
          </SelectItem>
          <SelectItem value="atendimento">
            <div className="flex items-center gap-2">
              <Smartphone className="h-3 w-3 text-green-500" />
              Atendimento
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
